import React, { useState, useRef, PropsWithChildren } from 'react';
import { useSlateStatic, ReactEditor } from 'slate-react';
import { Transforms } from 'slate';
import { ImageElement } from 'components/_new/NewSlateEditor/types';
import { EmbedElement } from './EmbedElement';

type ImageProps = PropsWithChildren<{
	element: ImageElement;
	attributes: Record<string, any>;
}>;

const Image = ({ attributes, element, children }: ImageProps) => {
	const { url, alt } = element;

	const imgRef = useRef<HTMLImageElement>(null);
	const [aspectRatio, setAspectRatio] = useState<number | undefined>(undefined);

	return (
		<EmbedElement attributes={attributes} element={element} aspectRatio={aspectRatio}>
			<img
				ref={imgRef}
				alt={alt}
				src={url}
				className="w-full"
				onLoad={() => {
					if (imgRef.current) {
						const { naturalWidth, naturalHeight } = imgRef.current;
						setAspectRatio(naturalWidth / naturalHeight);
					}
				}}
			/>
			{children}
		</EmbedElement>
	);
};
export default Image;
